import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

export default function ConfirmationModal() {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div>
      <IconButton
        sx={{ color: 'black' }}
        onClick={handleClickOpen}
      >
        <ArrowBackIosIcon />
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t('alertSaveTitle')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t('alertSaveMessage')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleGoHome} variant="contained" color="secondary">{t('yes')}</Button>
          <Button onClick={handleClose} variant="contained" autoFocus color="primary">
            {t('no')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
